import legal_participant_form from "dictionaries/legal_participant_form.json";
import createOptions from "utils/createOptions";

export default createOptions(legal_participant_form);
